import React from "react";
import "../Contactus/Place.css";

const places = [
  {
    id: 1,
    image: "p1.webp",
    location: "Jaipur",
    details:
      "The Pink City, known for its historic palaces, vibrant markets, and rich culture.",
  },
  {
    id: 2,
    image: "p2.webp",
    location: "Goa",
    details:
      "A tropical paradise famous for its beaches, nightlife, and Portuguese heritage.",
  },
  {
    id: 3,
    image: "p3.webp",
    location: "Varanasi",
    details:
      "One of the oldest cities in the world, celebrated for its spiritual essence and ghats.",
  },
];

const Place = () => {
  return (
    <section className="place-pp">
      <p className="place-title-pp">Locations</p>
      <h1 className="place-heading-pp">Work Places</h1>
      <div className="place-cards-container-pp">
        {places.map((place) => (
          <div key={place.id} className="place-card-pp">
            <img
              src={place.image}
              alt={place.location}
              className="place-image-pp"
            />
            <h3 className="place-location-pp">{place.location}</h3>
            <p className="place-details-pp">{place.details}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Place;
